import {
  Component
} from 'react';
import handlerMap from './handlerMap';
import * as urlHelper from '../util/url';
import * as helper from '../util/helper';
import { isEqualTo } from '../util/check';
import * as approvelHelper from '../util/approvelHelper';
import * as html from '../util/html';
import { getExtensionCmpByViewPath } from '../util/extension';
import transLoader from '@beisen/i18n-translation-loader';

const defaultTranslation = {
  validateRowsSingle: '请选择一条数据！',
  validateRowsOverSingle: '只能选择一条数据！',
  validateRowsMulti: '请至少选择一条数据！',
  defaultMsg: '是否要执行此操作？',
  noRedirectWarning: '没有配置跳转链接!'
};

const dataRowsEnum = {
  'none': 'none',
  'single': 'single',
  'multi': 'multi'
};
//将queue中去掉不合适的handler
const handler_filter = (handlerQueue, deleteHandlers) => {
  if (!Array.isArray(deleteHandlers)) {
    return null;
  }

  return handlerQueue.filter(handler => deleteHandlers.indexOf(handler) === -1);

  // deleteHandlers.forEach(handler => {
  //     if(handlerQueue.indexOf(handler) != -1) {
  //         handlerQueue.splice(handlerQueue.indexOf(handler),1);
  //     }
  // });
};

export default class ActionQueue extends Component {
  constructor(props, context) {
    super(props, context);
    this.actions = props.actions;
    this.handlers = [];
    this.params = {};
    this.parseParams();
    this.init();
    this.makeHandlerQueue(this.props.cmp_data.action, this.params);
    this.translation = Object.assign({}, defaultTranslation, transLoader({
      validateRowsSingle: 'table.validateRowsSingle',
      validateRowsOverSingle: 'table.validateRowsOverSingle',
      validateRowsMulti: 'table.validateRowsMulti',
      defaultMsg: 'tip.defaultMsg',
      noRedirectWarning: 'tip.noRedirectWarning'
    }), props.translation);
  }

  //初始化默认值
  init() {
    //处理默认的DataRows参数

    if ((this.params.formState || this.isBatchEdit() || this.isStaticButton()) && !this.params.dataRows) {
      this.initDataRowsParamWithDefault();
    }
  }

  //解析Button的参数
  parseParams() {
    const { cmp_data } = this.props;
    if (cmp_data.params) {
      cmp_data.params.split(',').forEach(kv => {
        let items = kv.split(':');
        if (kv.indexOf(':http:') >= 0) {
          items = kv.split(':http:');
          items[1] = 'http:' + items[1];
        } else if (kv.indexOf(':https:') >= 0) {
          items = kv.split(':https:');
          items[1] = 'https:' + items[1];
        }
        const key = items[0].trim();
        this.params[key] = items.length > 2 ? items[1].concat(':', items[2]) : items[1];
      });
    }
    if (!this.params.title) {
      this.params.title = html.decode(cmp_data.title);
    }
  }

  //#region 构造Button行为序列

  isInsertShowBatchAction() {
    if (this.props.cmp_data.level === 'listViewRow' || this.props.pageType == 'detail') {
      return false;
    }

    if (this.isNeedInsertShowBatchAction()) {
      return true;
    }


  }

  appendHandlerToTail(handler) {
    if (Array.isArray(handler)) {
      this.handlers = this.handlers.concat(handler);
    } else {
      this.handlers.push(handler);
    }

  }

  //追加jump的handler到handlers的尾部
  appendJumpHandlerToQueue() {
    if (this.params.jumpUrl) {//handles:{redirect:any}
      this.handlers.push('redirect');
    }

    if (this.params.getJumpUrlMode && this.params.getJumpUrlMode == 'response') {
      if (!this.params.method) {
        this.params.method = 'POST';
      }
      this.params.jumpUrl = 'result';
      this.handlers.push('redirect');
    }
  }

  //追加显示批量编辑的hadler到handers的头部
  appendShowBatchHandlerToQueueHead() {
    if (this.isInsertShowBatchAction()) {
      if (this.params.dataRows && this.params.dataRows != dataRowsEnum.none) {
        this.handlers.unshift('validateDataRows');
      }
      this.handlers.unshift('showBatch');
    }
  }

  indsertHandlerBefore(handlerName, insertHandlers) {
    const cur = this.handlers.indexOf(handlerName);
    if (cur != -1) {
      this.handlers = [...this.handlers.slice(0, cur), ...insertHandlers, ...this.handlers.slice(cur)];
    }
  }

  //根据params配置的notShowConfirm不显示确认框
  handleIsShowConfirm() {
    if (this.params.notShowConfirm && this.params.notShowConfirm != 'false') {
      this.handlers.shift();
    }
  }

  //通用的Handler构造方法
  commonHandlerQueueConstructor(actionName) {

    handlerMap[actionName] && handlerMap[actionName].forEach(item => {
      const items = item.split(':');
      if (items[0] == 'showPanel' || items[0] == 'openWin') {
        this.params.panelType = items[1];
        if (this.isBatchEdit() && this.params.model === 'form') {
          this.params.panelType = 'form';
        }
      }
      if (items[0] == 'showEditOwnerPanel') {
        this.params.panelType = items[1];
        this.params.formState = 'edit';
      }
      if (items[1] == 'delete') {
        this.params.ajaxUrl = helper.getAPI('DeleteApiUrl');
        this.params.method = 'DELETE';
        this.params.isDelete = true;
      }
      if (items[1] == 'logic') {
        this.params.ajaxUrl = helper.getAPI('LogicalDeleteUrl');
        this.params.method = 'POST';
        this.params.isDelete = true;
      }
      if (items[1] == 'index' || (this.params.hasOwnProperty('handles') && this.params.handles.match('index'))) {
        //如果是相关列表页跳转
        let queryUrl = this.props.queryUrl;
        if (this.props.cmp_data.level === 'detail') {
          //如果是相关列表列表页跳转到的详情页直接返回
          if (queryUrl.BasePageModule) {
            this.params.jumpUrl = 'goBack';
            //如果是从详情页相关列表跳转到详情页里再配置to index的按钮
          } else if (queryUrl.detaileBasePageModule) {
            let BasePageModuleParams = {};
            try {
              BasePageModuleParams = JSON.parse(decodeURIComponent(queryUrl.detaileBasePageModule));
              this.params.jumpUrl = helper.getBasePageModuleUrl(Object.assign(BasePageModuleParams, { shadow_context: queryUrl.shadow_context }));
            } catch (e) {
              this.params.jumpUrl = `${helper.getAPI('IndexPage')}${this.props.queryUrl && this.props.queryUrl.viewName ? ('&viewName=' + this.props.queryUrl.viewName) : ''}`;
            }
          } else {
            this.params.jumpUrl = `${helper.getAPI('IndexPage')}${this.props.queryUrl && this.props.queryUrl.viewName ? ('&viewName=' + this.props.queryUrl.viewName) : ''}`;
          }
          //如果是相关列表页或者相关视图index页
        } else if (queryUrl.viewpath === 'pageModule' || (this.props.cmp_data.level === 'index' && queryUrl.pageModule)) {
          this.params.jumpUrl = 'reload';
        } else {
          this.params.jumpUrl = `${helper.getAPI('IndexPage')}${this.props.queryUrl && this.props.queryUrl.viewName ? ('&viewName=' + this.props.queryUrl.viewName) : ''}`;
        }
      }
      if (items[1] == 'detail' || (this.params.hasOwnProperty('handles') && this.params.handles.match('detail'))) {

        this.params.jumpUrl = helper.getAPI('DetailPage');
      }
      this.handlers.push(items[0]);
    });

    this.handleIsShowConfirm();

    this.appendShowBatchHandlerToQueueHead();

    this.appendJumpHandlerToQueue();

    if (!this.isNeedJump()) {
      this.handlers.push('afterAction');
    }
  }

  isPopFormButton(actionName) {
    return actionName && actionName.startsWith('PopForm');
  }

  isApprovalButton(actionName, params) {
    return actionName === 'PopComponentButton' && params.componentName === 'ApprovalForm';
  }

  approvalHandlerQueueConstructor(actionName, params) {
    params.isApprovalButton = true;

    const hasApproverField = approvelHelper.getExistFields({ params }).length > 0;
    // params.AC_commentType 1：显示不必填 ，2显示必填，3不显示
    // const commentType = params.AC_commentType && params.AC_commentType;
    // const hasComment = commentType == '1' || commentType == '2';
    // const hasNextAppointApprover = params.appointApproverType && params.appointApproverType != 0 && params.isAppointComponent;
    // const hasTransfer = params.useTemplate === 'retweeted';
    // const hasJump = params.AC_jumpTo;
    // const hasField = hasComment || hasNextAppointApprover || hasTransfer || hasJump;
    //this.params.isApprovalButton = true;
    const approvalButtonParamsConvert = params => {
      if (params['formSaveUrl']) {
        params['completeTaskUrl'] = params['formSaveUrl'];
        delete params['formSaveUrl'];
      }

      if (params['formSaveUrl_Pre']) {
        params['formSaveUrl'] = params['formSaveUrl_Pre'];
      }
    };

    //#region 审批按钮最终实现效果
    //#endregion 审批按钮最终实现效果
    const dependencyActionName = params.actionType;
    const dependIsPopFormBtn = this.isPopFormButton(dependencyActionName);
    const dependIsStaticBtn = this.isStaticButton(dependencyActionName);

    approvalButtonParamsConvert(this.params);

    if (dependIsPopFormBtn || dependIsStaticBtn && !(dependIsStaticBtn && hasApproverField)) {
      params.disableSuccessTip = true;
      this.commonHandlerQueueConstructor(dependencyActionName);
      //移除掉这种场景下不能出现的handler
      let inValidHandlers = ['redirect', 'validateDataRows', 'showBatch'];
      if (dependIsStaticBtn && !hasApproverField) {
        //执行ajax，不填写审批意见
        this.appendHandlerToTail(['completeTask']);
      }
      this.handlers = handler_filter(this.handlers, inValidHandlers);
      this.appendHandlerToTail(['redirectAfterCompleteTask']);
    } else if (!hasApproverField) { //没有配置提交前检查按钮，但是字段都配置了不显示
      this.appendHandlerToTail(['confirmPop', 'completeTask', 'redirectAfterCompleteTask']);
    } else { //只有审批按钮默认的逻辑
      this.commonHandlerQueueConstructor(actionName);
      if (dependIsStaticBtn && hasApproverField) {
        params.disableSuccessTip = true;
        this.indsertHandlerBefore('showPanel', ['ajaxMethod']);
      };
    }


  }

  makeHandlerQueue(actionName, params) {
    if (this.isApprovalButton(actionName, params)) {
      this.approvalHandlerQueueConstructor(actionName, params);
      return null;
    }
    this.commonHandlerQueueConstructor(actionName);
  }

  //#endregion 构造Button行为序列

  isNeedJump() {
    if (this.params.jumpUrl || this.params.getJumpUrlMode && this.params.getJumpUrlMode == 'response') {
      return true;
    }
    return false;
  }

  isAjaxQueryBodyParam(paramName) {
    return paramName.startsWith('queryBody_');
  }

  hasPlaceholderParam(str) {
    if (!str) {
      return false;
    }
    return str.indexOf('{data.') !== -1;
  }

  //判断当前按钮是不是批量编辑按钮
  isBatchEdit() {
    return this.isSomeTypeButton('EditBatchButton');
  }

  //判断是不是StaticButton按钮
  isStaticButton(actionName = null) {
    if (actionName) {
      return actionName === 'StaticButton';
    }
    return this.isSomeTypeButton('StaticButton');
  }

  isSomeTypeButton(type) {
    return isEqualTo(this.props, ['cmp_data', 'action'], type);
  }

  //当前button的参数中是否包含占位符
  isParamsHasPlaceHoder() {
    return this.hasPlaceholderParam(this.params.jumpUrl) || this.hasPlaceholderParam(this.params.ajaxUrl) || this.hasPlaceholderParam(this.params.iframeUrl);
  }

  //当前按钮是否是编辑按钮
  isPopFormEditButton() {
    return this.params.formState === 'edit';
  }

  isNeedInsertShowBatchAction() {
    if (this.params.dataRows && this.params.dataRows === 'none') {
      return false;
    }

    if (this.isParamsHasPlaceHoder() || this.isPopFormEditButton() || this.isBatchEdit() || this.isStaticButton() || (this.params.dataRows && this.params.dataRows !== 'none')) {
      return true;
    }
    for (let prop in this.params) {
      if (this.isAjaxQueryBodyParam(prop) && this.hasPlaceholderParam(this.params[prop])) {
        return true;
      }
    }
    return false;
  }

  initDataRowsParamWithDefault() {
    if (this.isBatchEdit() || this.isStaticButton() || (this.params.formState && this.params.formState.toLowerCase() === 'edit')) {
      this.params.dataRows = 'multi';
    } else {
      this.params.dataRows = 'none';
    }
  }

  shouldComponentUpdate(nextprops, nextState) {
    if (nextprops.currentHandler === 0 && nextprops.isError) {
      return false;
    }
    return true;
  }

  componentWillReceiveProps(nextProps) {
    //如果静态按钮点击确定失败，则清空队列
    const flag = nextProps.ajaxTipType == 'ajaxTipType_fail' && nextProps.cmp_data.action === 'StaticButton';
    if (nextProps.currentHandler != this.props.currentHandler && !(nextProps.currentHandler === 999 && nextProps.isError) || flag) {
      if (nextProps.confirmActionType == 'cancle' || flag) {
        const showBatchIndex = this.handlers.indexOf('showBatch');
        if (showBatchIndex >= 0 && !flag) {
          this.props.actions.goBackHandlers();
        } else {
          this.props.actions.btnClearFn();
        }
      } else {
        this[this.handlers[nextProps.currentHandler]](nextProps, nextProps.currentHandler);
      }
    }
  }
  /*
   * 执行业务扩展的action
   */
  trigger(props, currentHandlerIndex) {
    //当Button的序列中只有扩展的行为的时候，不执行
    if (this.handlers.length === 1) {
      this.props.actions.btnClearFn();
    }
    //当前需要执行的自定义trigger是最后一个的时候,采用after_前面action名字命名
    //其余的时候trigger的名字采用before_后一个action命名，因为在执行序列中前一个action的after就是后一个action的before
    let prefix = '', actionName = '', buttonType = props.cmp_data.action || 'CustomButton';
    if (currentHandlerIndex === this.handlers.length - 2) {
      prefix = 'after';
      actionName = this.handlers[currentHandlerIndex - 1];
    } else {
      prefix = 'before';
      actionName = this.handlers[currentHandlerIndex + 1];
    }
    const contextParams = Object.assign({}, props, {
      afterAction: null,
      currentHandler: null,
      datatop: null,
      onTouchTap: null
    });
    const hookMethod = window._buttonActionHooks[`${buttonType}_${prefix}_${actionName}`];
    if (!hookMethod || Object.prototype.toString.call(hookMethod) !== '[object Function]') {
      this.props.actions.btnNextFn();
      return null;
    }
    const businessLogicComponent = hookMethod(contextParams);
    if (businessLogicComponent) {
      this.props.actions.excuteBusinessLogic({ view_path: businessLogicComponent, contextParams: contextParams });
    } else {
      this.props.actions.btnNextFn();
    }
  }


  businessLogic(props) {
    if (props.tempData && props.tempData.callBack) {
      this.actions.btnClearFn();
      props.tempData.callBack();
    }
  }

  showBatch() {
    this.actions.showBatch(this.props.data);
  }

  validateDataRows(props, currentHandler) {
    const { translation } = this;
    const selectedRowLength = props.data ? props.data.length : 0;
    let error = false, errorMessage = null;
    if (this.params.dataRows === dataRowsEnum.single && selectedRowLength !== 1) {
      error = true;
      if (selectedRowLength === 0) {
        errorMessage = translation.validateRowsSingle;
      } else {
        errorMessage = translation.validateRowsOverSingle;
      }
    } else if (this.params.dataRows === dataRowsEnum.multi && selectedRowLength < 1) {
      error = true;
      errorMessage = translation.validateRowsMulti;
    }
    if (error) {
      if (this.handlers[currentHandler + 1] !== 'validateDataRows') {
        this.handlers = [...this.handlers.slice(0, currentHandler + 1), 'validateDataRows', ...this.handlers.slice(currentHandler)];
      }
      this.props.actions.showTip(
        {
          message: errorMessage,
          type: 'error',
          isAutomaticCloseTip: true
        });
      return null;
    }
    this.props.actions.btnNextFn();
  }

  componentDidMount() {
    this[this.handlers[this.props.currentHandler]](this.props, this.props.currentHandler);
  }

  render() {
    return null;
  }

  afterAction(props) {
    const {
      afterAction,
      tempData,
      cmp_data
    } = props || this.props;
    let afterData = {};
    if (cmp_data.action == 'sortBtn') {
      afterData.sortData = tempData;
    }
    if (cmp_data.action == 'PopSearchForm') {
      afterData.searchData = tempData;
    }
    if (afterAction) {
      afterAction(afterData);
    }
    this.actions.btnClearFn();
  }

  isReplaceCurrentUrl(locationObj) {
    const currentPageIsDetailPage = locationObj.hash.toLowerCase().startsWith('#/detailpage');
    return currentPageIsDetailPage && (this.params.isDelete || (BSGlobal.application === 'ApprovalCentre' && window.env.platform.bsAppIOS));
  }

  /**
   前进 、 后退、 页面跳转
  **/
  redirect(props) {
    const {
      cmpContext,
      data,
      queryUrl,
      cmp_data,
      tempData
    } = props || this.props;
    const locationObj = window.location;
    this.actions.btnClearFn();
    if (cmp_data.action == 'GoBackButton') {
      helper.handleBack();
      return null;
    }
    if (cmp_data.action == 'GoForwardButton') {
      window.history.go(1);
      return null;
    }
    const param = (props.ajaxResp || {}).param;
    //如果是相关列表
    if (this.params.jumpUrl === 'reload') {
      helper.pageReload();
      return;
    }

    //如果是相关列表详情页，为了避免返回无效
    if (this.params.jumpUrl === 'goBack') {
      helper.handleBack();
      return;
    }
    if ((this.params.jumpUrl && this.params.jumpUrl != 'result') || (this.params.jumpUrl == 'result' && param)) {
      let copyData = {};
      for (let key in data[0]) {
        if (data[0][key] && toString.call(data[0][key]) === '[object Object]') {
          copyData[key] = data[0][key]['value'];
        } else {
          copyData[key] = data[0][key];
        }
      }
      let arr = [];
      arr.push(copyData);
      //根据上下文填充上下文，并补充
      let pageModule = queryUrl.pageModule ? JSON.parse(decodeURIComponent(queryUrl.pageModule)) : { 'metaObjName': cmpContext['metaObjName'] };
      Object.assign(cmpContext, { 'metaObjName': pageModule['metaObjName'] });
      let jumpUrl = '';

      if (this.params.jumpUrl === 'result') {
        jumpUrl = param;
      } else {
        jumpUrl = this.params.jumpUrl;
      }
      let signFormat = '';
      // 按钮跳页带id的去按钮的signFormat,否则取form保存成功之后接口的signFormat
      if(cmp_data.signFormat && jumpUrl.match(/&id=[^{]/g)) {
        signFormat = cmp_data.signFormat;
      } else if(tempData && tempData.signFormat) {
        signFormat = tempData.signFormat;
      }

      if(signFormat) {
        const signReg = /bc_(\S*)/g; // 去掉URL上自己添加的签名，替换成接口给的
        // 判断jumpurl是否是跳到详情页，并且有id占位符
        const urlReg = /(#\/detailPage)(\S*)&id={(.*?)}/g;
        if(jumpUrl.match(urlReg)) {
          jumpUrl = jumpUrl.replace(signReg,'');
        }
        jumpUrl = jumpUrl.endsWith('&') ? jumpUrl.concat(signFormat) : jumpUrl.concat('&' + signFormat);
      }

      jumpUrl = urlHelper.formatUrl(jumpUrl, queryUrl, cmpContext, arr, this.params);

      if (this.params.blank == 'true') {
        helper.pageJump(jumpUrl, {
          openModel: '_blank',
          isReplace: this.isReplaceCurrentUrl(locationObj)
        });
      } else {
        if (jumpUrl == location.href.split('&_k')[0]) {
          helper.pageReload();
        } else {
          helper.pageJump(jumpUrl, {
            isReplace: this.isReplaceCurrentUrl(locationObj)
          });
        }
      }
    } else {
      const { translation } = this;
      this.props.actions.showTip({
        message: translation.noRedirectWarning,
        type: 'warning'
      });
    }
  }

  formatMsg() {
    let msg = this.props.cmp_data.params.match(/ConfirmMessage([\s\S]+)/g)[0];
    if (msg) {
      msg = msg.split(',')[0].replace(/ConfirmMessage:/g, '');
    }
    return msg;
  }

  /*确定是否执行该操作！*/
  confirmPop() {
    let message = this.translation.defaultMsg;
    if (this.props.cmp_data.params.match(/ConfirmMessage([\s\S]+)/g)) {
      const confrimMessage = this.formatMsg();
      if (confrimMessage) {
        message = confrimMessage;
      }
    };
    // 扩展弹窗内容组件
    const extensionPath = this.params['ConfirmViewPath'];
    const ExtensionCmp = extensionPath && getExtensionCmpByViewPath(extensionPath);
    if (ExtensionCmp) {
      message = <ExtensionCmp ref={el => this.extConfirmEl = el} { ...this.props.cmp_data } />;
    }
    this.actions.showConfirm({
      title: html.decode(this.props.cmp_data.title),
      children: message
    });
  }

  //将cmp_data.params处理成对象 -- lianglongfei
  paramsFormat(params) {
    if (typeof params == 'object') {
      return params;
    }
    //移除所有空格和" ===> 如果key和value中有这些字符也会受到影响
    params = params.replace(/("+)|(\s+)/g, '').replace(/(:(?=,))|(:(?=$))/g, ': ');
    //给所有key 和 value 加上双引号
    params = params.replace(/:(.+?)(,|$)/g, ':"$1"$2').replace(/(^|,)(.+?):/g, '$1"$2":');
    return JSON.parse('{' + params + '}');
  }

  getAllParams(props) {
    const {
      cmpContext,
      queryUrl,
      data,
      tableData
    } = props || this.props;
    //格式化data,兼容
    let tempData = {};
    if (data && data.length > 0) {
      tempData = data[0];
      let newData = {
        id: tempData['_id']
      };
      newData.ids = data.map(row => {
        return toString.call(row['_id']) === '[object Object]' ? row['_id']['value'] : row['_id'];
      }).join(',');
      tempData = Object.assign({}, newData, tempData);
    }
    let allParams = Object.assign({}, {
      cmpContext,
      data: tempData,
      tableData: tableData,
      params: this.params,
      queryUrl
    });
    return allParams;
  }

  showPanel(props) {
    this.actions.showPop(this.getAllParams(props));
  }

  showEditOwnerPanel(props) {
    this.showPanel(props);
  }

  openWin(props) {
    let params = props['cmp_data']['params'] ? props['cmp_data']['params'] : '';
    let iframe = params.split(',')[0];
    let point = iframe.indexOf(':');
    let url = iframe.substr(point + 1).trim();
    this.actions.btnClearFn();
    if (url && url != '{0}') {
      helper.pageJump(url);
    }
  }

  ajaxMethod(props) {
    const { translation } = this;
    const {
      cmpContext,
      data,
      queryUrl,
      searchCriteria
    } = props || this.props;
    let {
      ajaxUrl,
      method,
      postSearchData
    } = this.params;
    if (!ajaxUrl || ajaxUrl === '{0}') {
      this.actions.showTip({
        message: translation.noRedirectWarning
        , type: 'error'
      });
      this.actions.btnClearFn();
      return;
    }

    const ajaxParams = helper.getAjaxListParams({ cmp_data: this.props.cmp_data, cmp_id: this.props.cmp_id }, 'ajaxUrl');
    method = ajaxParams ? ajaxParams.method : method;
    let copyData = {};
    for (let key in data[0]) {
      if (data[0][key] && toString.call(data[0][key]) === '[object Object]') {
        copyData[key] = data[0][key]['value'];
      } else {
        copyData[key] = data[0][key];
      }
    }
    let arr = [];
    arr.push(copyData);
    ajaxUrl = urlHelper.formatUrl(ajaxUrl, queryUrl, cmpContext, arr, this.params).trim();

    ajaxUrl = helper.urlCompletion(ajaxUrl);

    if (ajaxUrl.indexOf('app') < 0) {
      if (ajaxUrl.indexOf('?') >= 0) {
        ajaxUrl = ajaxUrl + '&app=' + BSGlobal.application;
      } else {
        ajaxUrl = ajaxUrl + '?app=' + BSGlobal.application;
      }
    }

    if (ajaxUrl.includes('/api/v2/data/ObjectData/') || ajaxUrl.includes('_LogicalDelete')) {
      this.params.isDelete = true;
    }
    // ajax弹窗扩展参数
    const extParams = this.extConfirmEl ? this.extConfirmEl.getParams && this.extConfirmEl.getParams() : {};
    const defaultParams = { ajaxUrl, method: method, analysisData: this.props.analysisData, disableSuccessTip: this.params.disableSuccessTip || false };
    const searchData = postSearchData ? { search_data: searchCriteria } : {};
    const queryBody = urlHelper.getButtonQueryBodyParams(this.params, this.props.data, queryUrl);
    const postData = Object.assign({}, searchData, queryBody, extParams);

    this.actions.btnAjaxFn(Object.assign({}, defaultParams, postData), ajaxParams ? helper.getFeatureToken(ajaxParams) : null);
  }


  redirectAfterCompleteTask(props) {
    this.actions.btnClearFn();

    //为了显示弹窗提示信息，所以做了2s的延时
    setTimeout(() => {
      const { queryUrl } = props;
      //如果是elink链接则不跳转，只reload
      if (queryUrl && queryUrl.shadow_context && queryUrl.shadow_context.indexOf('elinkId') > -1) {
        helper.pageReload();
        return false;
      }
      if (props.tempData && props.tempData.data && props.tempData.data.needBackToDetail) {
        // 如果有needBackToDetail标识则停在当页不动 如果还有needReload标识则刷新当前页
        if (props.tempData.data.needReload) {
          helper.pageReload();
        }
        return false;
      }
      helper.handleBack();
    }, 2000);
  }

  completeTask(props) {
    let submitParams = {};
    const fields = approvelHelper.getExistFields(props.popOptions);
    fields.forEach(field => {
      submitParams[field.taskKey] = props.tempData && props.tempData[field.name] || '';
    });

    // const queryObj = window.location;
    // const commentKey = BSGlobal.loginUserInfo.Id + "_" + queryObj['_processInstanceId'] + '_comment';
    //const wf_comment = props.tempData && props.tempData.wf_comment; //|| window.sessionStorage.getItem(commentKey) || '';
    //const submitParams = { comment: wf_comment };
    this.actions.btnAjaxFn({ ajaxUrl: urlHelper.keepHttpsProtocolSame(this.params.completeTaskUrl), method: 'POST', analysisData: this.props.analysisData || null, postData: submitParams }, null);
  }
}



// WEBPACK FOOTER //
// ./src/components/Button/ActionQueue.js